import Form from 'react-bootstrap/Form';
import { formatImage, formatPrice } from 'src/services/utils';
import SemFoto from 'src/img/semFoto.png';
import FooterSuporte from 'src/components/FooterSuporte';
import { Switch } from 'react-router-dom';

export function getVariantDataComponent(
  variantData,
  originalData,
  token,
  { setOpenModal },
) {
  if (variantData.variant) {
    const { image_url, sku, id, title, product_id, inventory_policy } =
      variantData.variant;

    return (
      <>
        <div className="row my-2 d-flex align-items-center">
          <h1 className="title-section fw-normal fs-3 d-flex align-items-center">
            Produto {variantData.product.title}
            {!!originalData && originalData.variants.length > 1 && (
              <>
                {' '}
                <div className="ms-2 d-none d-md-flex align-items-center">
                  /
                  <Form.Select
                    onChange={e => {
                      const element = e.target;
                      const { value } = element;
                      if (parseInt(value, 10) !== 0)
                        window.location.replace(value);
                    }}
                    className="ms-2 py-2"
                  >
                    <option value="0" key={id}>
                      {title}
                    </option>
                    {originalData.variants.map(({ id, title }) => {
                      if (id === variantData.variant.id) return null;

                      return (
                        <option value={id} key={id}>
                          {title}
                        </option>
                      );
                    })}
                  </Form.Select>
                </div>
              </>
            )}
            {originalData && originalData.handle ? (
              <a
                className="text-secondary text-decoration-none "
                target="_blank"
                href={`https://inventa.shop/products/${originalData.handle}?variant=${id}`}
                rel="noreferrer"
              >
                <div className="ms-2 position-relative">
                  <i className="fas fa-external-link-alt position-absolute fs-5 ps-2 ms-1" />
                  <span
                    className="d-block pt-4 mt-2"
                    style={{ fontSize: '10px' }}
                  >
                    visualizar
                  </span>
                </div>
              </a>
            ) : null}
          </h1>
        </div>
        <div className="row">
          <div className="col-12">
            <img
              src={image_url ? formatImage(image_url, '_240x240') : SemFoto}
              alt={title}
            />
          </div>
        </div>
        <div className="row mt-3">
          {sku && (
            <div className="col-12">
              <p className="fw-bold text-uppercase mb-0">SKU</p>
              <p className="text-secondary">{sku}</p>
            </div>
          )}
        </div>
        <div className="row">
          {!!(variantData && originalData && originalData.options.length) && (
            <div className="col-12">
              {originalData.options.map((item, index) => {
                if (variantData.variant[`option${index + 1}`]) {
                  return (
                    <div key={item.name}>
                      <p className="fw-bold text-uppercase mb-0">{item.name}</p>
                      <p className="text-secondary">
                        {variantData.variant[`option${index + 1}`]}
                      </p>
                    </div>
                  );
                }
                return null;
              })}
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-12">
            <table className="table table-striped table__td">
              <thead>
                <tr>
                  <th scope="col">SKU</th>
                  <th scope="col">Nome</th>
                  <th scope="col" className="txt-center">
                    Valor
                  </th>
                  <th scope="col" className="txt-center">
                    Disponível
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{sku || ' - '}</td>
                  <td>
                    {variantData.product ? variantData.product.title : ''}
                  </td>
                  <td className="txt-center">
                    {originalData && originalData.full_price
                      ? formatPrice(originalData.full_price)
                      : '-'}
                  </td>
                  <td className="txt-center">
                    {!!(variantData && originalData) && (
                      <Switch
                        disabled={
                          !!(originalData && originalData.status === 'draft')
                        }
                        width={70}
                        onColor="#222222"
                        offColor="#F2F2F2"
                        onHandleColor="#222222"
                        offHandleColor="#222222"
                        checked={
                          !!(
                            originalData &&
                            originalData.status !== 'draft' &&
                            inventory_policy === 'continue'
                          )
                        }
                        onChange={checked => {
                          if (originalData && originalData.status !== 'draft')
                            setOpenModal({
                              productID: product_id,
                              variantID: id,
                              action: checked ? 'activate' : 'deactivate',
                              token,
                            });
                        }}
                        uncheckedIcon={
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              fontSize: 15,
                              color: '#666666',
                              paddingRight: 2,
                              paddingBottom: 3,
                            }}
                          >
                            não
                          </div>
                        }
                        checkedIcon={
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'center',
                              alignItems: 'center',
                              height: '100%',
                              fontSize: 15,
                              color: '#F2F2F2',

                              paddingRight: 2,
                              paddingBottom: 3,
                            }}
                          >
                            sim
                          </div>
                        }
                      />
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <FooterSuporte />
      </>
    );
  }
  return null;
}
